import { render, staticRenderFns } from "./ShareBar.vue?vue&type=template&id=6bc0d9a2&scoped=true&"
import script from "./ShareBar.vue?vue&type=script&lang=ts&"
export * from "./ShareBar.vue?vue&type=script&lang=ts&"
import style0 from "./ShareBar.vue?vue&type=style&index=0&id=6bc0d9a2&scoped=true&lang=less&"
import style1 from "./ShareBar.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc0d9a2",
  null
  
)

export default component.exports